<div class="content-container mb-3">
    <div class="content">
        <div class="message-card blue-fill mb-3">
            <div [innerHTML]="checkoutSurcharge.disclaimerText | pipeSafeHTML" class="mb-3">
            </div>
        </div>
        <div class="text-start">
            <mwp-radio-button [form]="surchargeForm" nameForControl="coverageDetailID" [data]="checkoutSurcharge.coverageDetails" keyValue="coverageID" keyText="alternateDescription" [displayInline]="false" />
        </div>
    </div>
</div>
<div>
    <mwp-benefit-enrollment-wizard-control [isCheckout]="true" [isContinueDisabled]="surchargeForm.invalid" (emitComplete)="complete()" />
</div>